import client from './client';
import { PlatformStatisticResponse } from '../interfaces';

const getPlatformStatistic = async () => {
  const url = `/api/recordCounts`;
  const res = await client.get<PlatformStatisticResponse>(url);

  return res.data;
};

export { getPlatformStatistic };
